import { render, staticRenderFns } from "./challenges.vue?vue&type=template&id=0cb5b23e&scoped=true"
import script from "./challenges.vue?vue&type=script&lang=js"
export * from "./challenges.vue?vue&type=script&lang=js"
import style0 from "./challenges.vue?vue&type=style&index=0&id=0cb5b23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5b23e",
  null
  
)

export default component.exports